import type { AuthTeardownParticipant } from './auth-teardown';

/**
 * The tab-scoped key the signup flow keeps its resume answers under (the
 * signup feature owns what goes in it). Named here so the session boundary can
 * clear it on any page, including one that never loaded the signup flow.
 */
export const SIGNUP_FLOW_STORAGE_KEY = 'galapagos.signup.flow';

export function removeStoredSignupFlow(): void {
  try {
    window.sessionStorage.removeItem(SIGNUP_FLOW_STORAGE_KEY);
  } catch {
    // Nothing to clear when storage is unreadable.
  }
}

/** Clears the kept signup answers when the session ends, on whatever page it ends. */
export const signupFlowStorageTeardownParticipant: AuthTeardownParticipant = {
  id: 'signup-flow-storage',
  clear: () => removeStoredSignupFlow(),
};
